import { compareDesc, compareAsc } from "date-fns";
import { Row } from "react-table";
import {InsuranceDoctorDto} from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

export const sortDoctorsByDate = (
  rowA: Row<InsuranceDoctorDto>,
  rowB: Row<InsuranceDoctorDto>,
  _: string,
  desc: boolean
) => {
  const { date: dateA } = rowA.values;
  const { date: dateB } = rowB.values;

  if (desc) {
    if (dateA == undefined) {
      return dateB == undefined
        ? 0
        : -1
    }

    if (dateB == undefined) {
      return dateA == undefined
        ? 0
        : 1
    }
    
    return compareDesc(dateA, dateB) * -1;
  }

  if (!desc) {
    if (dateA == undefined) {
      return dateB == undefined
        ? 0
        : 1
    }

    if (dateB == undefined) {
      return dateA == undefined
        ? 0
        : -1
    }

    return compareAsc(dateA, dateB);
  }

}
